import React from 'react';

const SingleSignOnSVG = () =>
  <svg width="53" height="53" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path
        d="M52.509 26.254C52.509 11.754 40.755 0 26.255 0 11.755 0 0 11.754 0 26.254c0 14.5 11.755 26.254 26.255 26.254 14.5 0 26.254-11.754 26.254-26.254"
        fill="#ECECEC"
      />
      <g fill="#FFF">
        <path
          d="M31.2 20.948c0-3.285-2.686-5.948-6-5.948s-6 2.663-6 5.948c0 3.285 2.686 5.949 6 5.949s6-2.664 6-5.949"
          stroke="#EB5424"
          strokeWidth="1.62"
        />
        <path
          d="M33.272 30.731l-6.556-2.182v-6.542a1.456 1.456 0 0 0-2.914 0V34.44l-3.253-3.248A1.495 1.495 0 0 0 18 32.245c0 .395.157.775.437 1.053l4.224 4.217c.314.314 1.14.485 1.14.485h9.471a.724.724 0 0 0 .728-.727v-5.817a.728.728 0 0 0-.728-.726v.001z"
          stroke="#222228"
          strokeWidth="1.215"
        />
      </g>
    </g>
  </svg>;

export default SingleSignOnSVG;



// WEBPACK FOOTER //
// ./src/svg/SingleSignOnSVG.js